import { render, staticRenderFns } from "./xplorer-table.vue?vue&type=template&id=976fbe5a&"
import script from "./xplorer-table.vue?vue&type=script&lang=ts&"
export * from "./xplorer-table.vue?vue&type=script&lang=ts&"
import style0 from "./xplorer-table.vue?vue&type=style&index=0&id=976fbe5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports